import {SVGProps} from "react"

const InProgress = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.485 9.81786C12.4043 10.0007 12.3803 10.2034 12.4159 10.4C12.4516 10.5966 12.5453 10.7781 12.685 10.9209L12.7214 10.9573C12.8341 11.0698 12.9235 11.2035 12.9845 11.3507C13.0455 11.4978 13.0769 11.6555 13.0769 11.8148C13.0769 11.9741 13.0455 12.1318 12.9845 12.279C12.9235 12.4261 12.8341 12.5598 12.7214 12.6724C12.6088 12.7851 12.4751 12.8745 12.328 12.9355C12.1808 12.9965 12.0231 13.0279 11.8638 13.0279C11.7045 13.0279 11.5468 12.9965 11.3996 12.9355C11.2525 12.8745 11.1188 12.7851 11.0062 12.6724L10.9699 12.636C10.827 12.4963 10.6456 12.4026 10.449 12.3669C10.2524 12.3313 10.0496 12.3554 9.86683 12.436C9.68758 12.5129 9.5347 12.6404 9.42702 12.803C9.31933 12.9656 9.26155 13.1562 9.26077 13.3512V13.4542C9.26077 13.7757 9.13306 14.084 8.90575 14.3113C8.67843 14.5386 8.37012 14.6663 8.04865 14.6663C7.72717 14.6663 7.41887 14.5386 7.19155 14.3113C6.96423 14.084 6.83653 13.7757 6.83653 13.4542V13.3997C6.83183 13.1991 6.7669 13.0045 6.65017 12.8413C6.53344 12.6781 6.37031 12.5538 6.18198 12.4845C5.99918 12.4038 5.79641 12.3798 5.59981 12.4154C5.4032 12.4511 5.22179 12.5448 5.07895 12.6845L5.04259 12.7209C4.93001 12.8336 4.79633 12.923 4.64918 12.984C4.50203 13.045 4.3443 13.0764 4.18501 13.0764C4.02572 13.0764 3.86799 13.045 3.72084 12.984C3.57369 12.923 3.44001 12.8336 3.32744 12.7209C3.21474 12.6083 3.12533 12.4746 3.06433 12.3275C3.00333 12.1803 2.97194 12.0226 2.97194 11.8633C2.97194 11.704 3.00333 11.5463 3.06433 11.3991C3.12533 11.252 3.21474 11.1183 3.32744 11.0057L3.3638 10.9694C3.50352 10.8265 3.59724 10.6451 3.63289 10.4485C3.66854 10.2519 3.64447 10.0491 3.5638 9.86634C3.48697 9.68709 3.35941 9.53421 3.19681 9.42653C3.03421 9.31885 2.84367 9.26106 2.64865 9.26028H2.54562C2.22414 9.26028 1.91584 9.13258 1.68852 8.90526C1.4612 8.67794 1.3335 8.36963 1.3335 8.04816C1.3335 7.72668 1.4612 7.41838 1.68852 7.19106C1.91584 6.96374 2.22414 6.83604 2.54562 6.83604H2.60016C2.80077 6.83135 2.99532 6.76641 3.15853 6.64968C3.32173 6.53295 3.44605 6.36982 3.51531 6.18149C3.59599 5.9987 3.62006 5.79592 3.58441 5.59932C3.54876 5.40271 3.45503 5.2213 3.31531 5.07846L3.27895 5.0421C3.16625 4.92953 3.07685 4.79584 3.01585 4.64869C2.95485 4.50154 2.92345 4.34381 2.92345 4.18452C2.92345 4.02523 2.95485 3.8675 3.01585 3.72035C3.07685 3.5732 3.16625 3.43952 3.27895 3.32695C3.39152 3.21425 3.52521 3.12484 3.67236 3.06384C3.81951 3.00285 3.97723 2.97145 4.13653 2.97145C4.29582 2.97145 4.45355 3.00285 4.6007 3.06384C4.74785 3.12484 4.88153 3.21425 4.9941 3.32695L5.03047 3.36331C5.1733 3.50303 5.35472 3.59676 5.55132 3.6324C5.74792 3.66805 5.9507 3.64399 6.1335 3.56331H6.18198C6.36124 3.48648 6.51411 3.35892 6.62179 3.19632C6.72948 3.03372 6.78726 2.84318 6.78804 2.64816V2.54513C6.78804 2.22365 6.91575 1.91535 7.14306 1.68803C7.37038 1.46071 7.67869 1.33301 8.00016 1.33301C8.32164 1.33301 8.62995 1.46071 8.85726 1.68803C9.08458 1.91535 9.21228 2.22365 9.21228 2.54513V2.59967C9.21306 2.7947 9.27085 2.98524 9.37853 3.14784C9.48621 3.31044 9.63909 3.438 9.81834 3.51483C10.0011 3.5955 10.2039 3.61957 10.4005 3.58392C10.5971 3.54827 10.7785 3.45455 10.9214 3.31483L10.9577 3.27846C11.0703 3.16576 11.204 3.07636 11.3511 3.01536C11.4983 2.95436 11.656 2.92296 11.8153 2.92296C11.9746 2.92296 12.1323 2.95436 12.2795 3.01536C12.4266 3.07636 12.5603 3.16576 12.6729 3.27846C12.7856 3.39104 12.875 3.52472 12.936 3.67187C12.997 3.81902 13.0284 3.97675 13.0284 4.13604C13.0284 4.29533 12.997 4.45306 12.936 4.60021C12.875 4.74736 12.7856 4.88104 12.6729 4.99361L12.6365 5.02998C12.4968 5.17281 12.4031 5.35423 12.3674 5.55083C12.3318 5.74744 12.3559 5.95021 12.4365 6.13301V6.18149C12.5134 6.36075 12.6409 6.51362 12.8035 6.62131C12.9661 6.72899 13.1567 6.78678 13.3517 6.78755H13.4547C13.7762 6.78755 14.0845 6.91526 14.3118 7.14258C14.5391 7.36989 14.6668 7.6782 14.6668 7.99967C14.6668 8.32115 14.5391 8.62946 14.3118 8.85677C14.0845 9.08409 13.7762 9.2118 13.4547 9.2118H13.4002C13.2051 9.21257 13.0146 9.27036 12.852 9.37804C12.6894 9.48572 12.5618 9.6386 12.485 9.81786V9.81786Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
const Pending = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"

  >
    <path
      d="M8.00016 14.6663C11.6821 14.6663 14.6668 11.6816 14.6668 7.99967C14.6668 4.31778 11.6821 1.33301 8.00016 1.33301C4.31826 1.33301 1.3335 4.31778 1.3335 7.99967C1.3335 11.6816 4.31826 14.6663 8.00016 14.6663Z"
      stroke={props.fill ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00016 8.66634C8.36835 8.66634 8.66683 8.36786 8.66683 7.99967C8.66683 7.63148 8.36835 7.33301 8.00016 7.33301C7.63197 7.33301 7.3335 7.63148 7.3335 7.99967C7.3335 8.36786 7.63197 8.66634 8.00016 8.66634Z"
      fill="#1D1D1E"
      stroke={props.fill ?? "#1D1D1E"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3332 8.66634C11.7014 8.66634 11.9998 8.36786 11.9998 7.99967C11.9998 7.63148 11.7014 7.33301 11.3332 7.33301C10.965 7.33301 10.6665 7.63148 10.6665 7.99967C10.6665 8.36786 10.965 8.66634 11.3332 8.66634Z"
      fill="#1D1D1E"
      stroke={props.fill ?? "#1D1D1E"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66667 8.66634C5.03486 8.66634 5.33333 8.36786 5.33333 7.99967C5.33333 7.63148 5.03486 7.33301 4.66667 7.33301C4.29848 7.33301 4 7.63148 4 7.99967C4 8.36786 4.29848 8.66634 4.66667 8.66634Z"
      fill="#1D1D1E"
      stroke={props.fill ?? "#1D1D1E"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
const Submitted = (props: SVGProps<SVGSVGElement>) => (
  <svg
    version="1.1" id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={props.width ?? 24}
    y={props.height ?? 24}
    width={props.width ?? 24}
    height={props.height ?? 24}
    viewBox="0 0 160 144"
    enable-background="new 0 0 160 144"
    fill={props.stroke ?? "#fff"}
    style={{marginLeft: "-2px"}}
  >
    <path
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? 10}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M56.033474,64.939697 C52.771999,50.959610 46.883850,38.459332 40.933411,25.983210 C39.798538,23.603754 38.666004,21.223181 37.532394,18.843122 C37.831116,18.417284 38.129837,17.991444 38.428558,17.565605 C75.882729,35.091618 113.336899,52.617626 150.791061,70.143639 C150.864365,70.713631 150.937653,71.283630 151.010956,71.853622 C113.649246,89.647842 76.287544,107.442062 38.548573,125.415955 C37.698704,122.127098 39.323513,120.412491 40.191692,118.574524 C46.379238,105.475281 52.673626,92.428085 56.022049,78.212631 C57.033672,73.917862 57.028908,69.648117 56.033474,64.939697 z"/>
  </svg>
)
const Cancelled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 22 22"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
      stroke={props.fill ?? "#858585"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 8L8 14"
      stroke={props.fill ?? "#858585"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8L14 14"
      stroke={props.fill ?? "#858585"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
const Saved = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H14L19 6V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19Z"
      stroke={props.stroke ?? "#858585"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 19V11H6V19" stroke={props.stroke ?? "#858585"} strokeWidth="2" strokeLinecap="round"
          strokeLinejoin="round"/>
  </svg>
)
const Uploaded = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 21C6.68054 21 3 21 3 21C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H10L17 8V12"
      stroke={props.fill ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 1V8H17"
      stroke={props.fill ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 16L15 20.01L13 18"
      stroke={props.fill ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
const Rejected = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.29 2.85999L1.81999 17C1.64536 17.3024 1.55296 17.6453 1.55198 17.9945C1.551 18.3437 1.64148 18.6871 1.81442 18.9905C1.98735 19.2939 2.23672 19.5467 2.5377 19.7238C2.83868 19.9009 3.18079 19.9962 3.52999 20H20.47C20.8192 19.9962 21.1613 19.9009 21.4623 19.7238C21.7633 19.5467 22.0126 19.2939 22.1856 18.9905C22.3585 18.6871 22.449 18.3437 22.448 17.9945C22.447 17.6453 22.3546 17.3024 22.18 17L13.71 2.85999C13.5317 2.5661 13.2807 2.32311 12.9812 2.15447C12.6817 1.98584 12.3437 1.89725 12 1.89725C11.6563 1.89725 11.3183 1.98584 11.0188 2.15447C10.7193 2.32311 10.4683 2.5661 10.29 2.85999V2.85999Z"
      stroke={props.fill ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8V12"
      stroke={props.fill ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16H12.01"
      stroke={props.fill ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const HasRejection = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 22 22"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.86 1H15.14L21 6.86V15.14L15.14 21H6.86L1 15.14V6.86L6.86 1Z"
      stroke={props.fill ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 7V11"
      stroke={props.fill ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 15H11.01"
      stroke={props.fill ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
const Approved = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 22 22"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
      stroke={props.fill ?? "#3CB877"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 9L10 14.01L7 11.01"
      stroke={props.fill ?? "#3CB877"}
      strokeWidth={props.strokeWidth ?? 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const StatusIcons = {
  InProgress,
  Pending,
  Submitted,
  Cancelled,
  Saved,
  Uploaded,
  Rejected,
  HasRejection,
  Approved
};

const Icons = {
  StatusIcons
}
export {StatusIcons};
export default Icons;
